// extracted by mini-css-extract-plugin
export default {"cartPageContainer":"CartPage_cartPageContainer__Vd+ul","totalPrice":"CartPage_totalPrice__NYfHr","purchaseBtn":"CartPage_purchaseBtn__c-ZrN"};